import { takeEvery } from 'redux-saga/effects'

import { VISIT_PATH } from 'quick-quote/ui/actions'

/**
 * @param serviceWrapper {Awaited<ReturnType<import('core/service-wrapper/wrapper').buildServiceWrapper>>}
 */
export function* sagas(serviceWrapper) {
  if (serviceWrapper.usePartnerApi) {
    yield [takeEvery(VISIT_PATH, serviceWrapper.subscribeRouteChange)]
  }
}
